import GameAnalytics from "not-game-analytics"

import App from "@frog/source/models/App.js"
import Stage from "@frog/source/models/Stage.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"

import Audiomix from "@frog/source/engine/Audiomix.js"
import Timings from "@frog/source/engine/animating/utility/Timings.js"
import * as Motions from "@frog/source/engine/animating/utility/Motions.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"

export function MoveToNewEncounter({nextEncounterKey, spotTag} = {}) {
    return function(stage) {
        const currentEncounter = stage.encounters[stage.currentEncounterKey]
        const nextEncounter = stage.encounters[nextEncounterKey]

        const alliedUnits = Object.values(stage.units).filter((unit) => {
            return unit.isDead != true
                && unit.affiliation == stage.player.affiliation
                && Zone.isInBounds(currentEncounter, unit.position)
                // && (unitKeys == undefined || unitKeys.includes(unit.key))
        })

        let spots = stage.world.spots
        if(Object.values(spots)[0] instanceof Array) {
            spots = spots[spotTag]
        } else {
            spots = Object.values(spots).filter((spot) => spot.tag == spotTag)
        }

        if(spots.length > 0) {
            spots = spots.filter((spot) => {
                const collidingUnits = Object.values(stage.units).filter((unit) => {
                    return unit.position.x == spot.position.x
                        && unit.position.y == spot.position.y
                        && unit.position.z == spot.position.z
                        && unit.type != "spot" && unit.type != "zone"
                })

                return collidingUnits.length == 0
                    && (Zone.isInBounds(nextEncounter, spot.position))
            })

            if(spots.length > 0) spawnSpots = spots
        }

        return [
            Step.deltastage({
                "player": {
                    "phase": "moving",
                    "zoomout": 1,
                },
            }),
            {"func": () => GameAnalytics.reportStageSuccess("chapter-" + stage.chapterSlug, "encounter-" + stage.currentEncounterKey)},
            {"func": () => GameAnalytics.reportStageStart("chapter-" + stage.chapterSlug, "encounter-" + nextEncounterKey)},
            {"func": () => App.game.chapter.selection.pointer = {"position": {"x": 16 / 2, "y": 9 / 2}, "mode": "none"}},
            // {
            //     "func": (stage) => {
            //         if(stage.encounters[nextEncounterKey] != undefined) {
            //             stage.encounters[nextEncounterKey].hasBeenSeen = true
            //         }
            //         if(stage.encounters[stage.currentEncounterKey] != undefined) {
            //             stage.encounters[stage.currentEncounterKey].hasBeenSeen = true
            //         }
            //     }
            // },
            {
                "name": "JumpToDifferentChapterEncounter",
                "deltastages": [
                    {"currentEncounterKey": nextEncounterKey},
                    {"turn": {"number": 0, "phase": "start", "affiliation": stage.player.affiliation}},
                    {"camera": {"speed": 0.05}}
                ]
            },
            {
                "name": "MoveUnits",
                "type": "invoke skill",
                "deltastages": [
                    alliedUnits.map((unit, index) => {
                        const spawnSpot = spawnSpots[index]
                        if(spawnSpot == undefined) return undefined
                        return {
                            "mark": 0,
                            "unit": {
                                "key": unit.key,
                                "position": {
                                    "x": spawnSpot.position.x,
                                    "y": spawnSpot.position.y,
                                    "z": spawnSpot.position.z,
                                },
                                "isRemoved": false,
                                "energy": {
                                    "invoke skill": true,
                                    "move": true,
                                }
                            }
                        }
                    }),
                ]
            },
        ]
    }
}
